import React, { useEffect, useRef, useState } from 'react';

import Konva from 'konva';
import { Group, Image } from 'react-konva';
import useImage from 'use-image';

import { getImageDetailsCover, handleCoverDrag } from '@eltoro-ui/creative_generator/Helpers';

import type { ICanvasDimensions } from 'Components/CanvasEditor/types';

type TBackgroundImageProps = {
  background_url: string;
  canvasDimensions: ICanvasDimensions;
};

export default function BackgroundImage({
  background_url,
  canvasDimensions: { canvasWidth, canvasHeight },
}: TBackgroundImageProps) {
  const imageRef = useRef<Konva.Image>(null);
  const [img] = useImage(background_url, 'anonymous');
  const [photoDims, setPhotoDims] = useState<{ width: number; height: number } | undefined>(
    undefined
  );
  const [photoPos, setPhotoPos] = useState<{ x: number; y: number } | undefined>(undefined);

  useEffect(() => {
    if (!imageRef.current || !img) return;
    const imageDetails = getImageDetailsCover(imageRef.current, {
      width: img.width,
      height: img.height,
    });
    if (!photoDims)
      setPhotoDims({
        width: imageDetails.width,
        height: imageDetails.height,
      });
    if (!photoPos)
      setPhotoPos({
        x: imageDetails.x,
        y: imageDetails.y,
      });
  }, [img?.id]);

  return (
    <Group
      name="background-image"
      onDragMove={evt => (evt.cancelBubble = true)}
      x={0}
      y={0}
      width={canvasWidth}
      height={canvasHeight}
      clipFunc={(ctx: CanvasRenderingContext2D) => {
        ctx.rect(0, 0, canvasWidth, canvasHeight);
      }}
    >
      <Image
        ref={imageRef}
        image={img}
        x={photoPos?.x}
        y={photoPos?.y}
        width={photoDims?.width}
        height={photoDims?.height}
        onDragStart={e => (e.cancelBubble = true)}
        draggable
        onDragEnd={e => {
          setPhotoPos({
            x: e.currentTarget.x(),
            y: e.currentTarget.y(),
          });
        }}
        dragBoundFunc={pos => handleCoverDrag(pos, imageRef.current)}
      />
    </Group>
  );
}
